exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cursor-pointer[data-v-76d2021e]{cursor:pointer}.card-body-minimum[data-v-76d2021e]{min-height:100px}.wr-signal-dot[data-v-76d2021e]{position:fixed;bottom:12px;right:12px;width:10px;height:10px;border-radius:50%;z-index:9000;cursor:default;transition:background .3s}.dot-connecting[data-v-76d2021e]{background:#f0a500;animation:dot-blink-76d2021e 1.2s ease-in-out infinite}.dot-connected[data-v-76d2021e]{background:#4caf50}.dot-error[data-v-76d2021e]{background:#e53935}@keyframes dot-blink-76d2021e{0%,to{opacity:1}50%{opacity:.3}}", ""]);

// exports
